import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import {
  NotificationEventType,
  NotificationEventTypeListFilterInput,
  NotificationEventTypesDocument,
  NotificationListSortingInput,
  PaginationInput,
} from 'src/graphql/generated/graphql';

export const useNotificationEventTypes = ({
  filter,
  pagination,
  sorting,
}: {
  filter?: NotificationEventTypeListFilterInput;
  pagination?: PaginationInput;
  sorting?: NotificationListSortingInput;
} = {}) => {
  const { data, loading } = useQuery(NotificationEventTypesDocument, {
    variables: {
      filter,
      pagination,
      sorting,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  const records = useMemo(
    () => data?.notificationEventTypes?.records || [],
    [data?.notificationEventTypes?.records],
  );

  const groupedRecords = useMemo(() => {
    return records.reduce(
      (acc, eventType) => {
        acc[eventType.category] = acc[eventType.category] || [];
        acc[eventType.category].push(eventType);

        return acc;
      },
      {} as Record<string, NotificationEventType[]>,
    );
  }, [records]);

  return {
    notificationEventTypes: records,
    groupedNotificationEventTypes: groupedRecords,
    loading,
  };
};
